Ext.define('SA.data.CountryCategoryList', {
    statics: {
        importsCategoryId: 'imports',

        getImportsCategoryId() {
            return this.importsCategoryId;
        },

        isImportsCategoryId(id) {
            return id === this.getImportsCategoryId();
        },
    },

    constructor(countryCode) {
        this.countryCode = countryCode;

        this.categories = [{
            id: this.self.importsCategoryId,
            name: 'My Imported Data',
            available: true,
            hasAcsData: false,
            hasScarboroughCrosstabData: false,
            hasSimmonsCrosstabData: false
        }];
    },

    getCountry() {
        return this.countryCode;
    },

    getData() {
        return this.categories.slice();
    },

    async load() {
        var Facets = SA.data.AttributeFacets,
            categories = Facets.getCategoriesByCountry(this.countryCode),
            ids = categories.map(({id}) => id),
            allQuery = this.runQuery({ids}),
            acsQuery = this.runQuery({ids, acsOnly: true}),
            scarboroughCrosstabQuery = this.runQuery({ids, scarboroughCrosstabOnly: true}),
            simmonsCrosstabQuery = this.runQuery({ids, simmonsCrosstabOnly: true}),
            [allResult, acsResult, scarboroughCrosstabResult, simmonsCrosstabResult] = await Promise.all([allQuery, acsQuery, scarboroughCrosstabQuery, simmonsCrosstabQuery]);

        this.categories.push(...categories.map(({id, name}) => {
            var available = !!allResult[id]['true'],
                hasAcsData = !!acsResult[id]['true'],
                hasScarboroughCrosstabData = !!scarboroughCrosstabResult[id]['true'],
                hasSimmonsCrosstabData = !!simmonsCrosstabResult[id]['true'];

            return {id, name: SA.localize(name), available, hasAcsData, hasScarboroughCrosstabData, hasSimmonsCrosstabData};
        }));
    },

    runQuery({ids, acsOnly, scarboroughCrosstabOnly = false, simmonsCrosstabOnly = false}) {
        var query = SA.data.Query.from({
            type: 'attributes',
            facets: ids,
            where: SA.data.AttributesQuery.getCountryAndStatusVisiblePredicate(this.countryCode),
            acsOnly,
            scarboroughCrosstabOnly,
            simmonsCrosstabOnly
        });

        return query.run().then(({facets}) => facets);
    }
});